import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto space-y-6">
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium"
            style={{ backgroundColor: 'var(--color-success-bg)', color: 'var(--color-success)' }}
          >
            <Icon name="Leaf" size={18} color="var(--color-success)" />
            Grünere Zukunft schaffen
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight">
            THG-Prämie für Elektrofahrzeuge
          </h1>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
            Als Halter eines Elektrofahrzeugs haben Sie Anspruch auf ein CO₂‑Zertifikat. Grid Balance übernimmt die komplette Abwicklung für Sie – professionell, transparent und ohne Aufwand.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8">
            <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name="Euro" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">Attraktive Prämie</h3>
              <p className="text-sm text-muted-foreground">Profitieren Sie von der THG-Quote für Ihr Elektrofahrzeug.</p>
            </div>
            
            <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name="CheckCircle2" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">Alles für Sie erledigt</h3>
              <p className="text-sm text-muted-foreground">Wir kümmern uns um Antrag & Abwicklung beim Umweltbundesamt.</p>
            </div>
            
            <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name="Shield" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">Sicher & Transparent</h3>
              <p className="text-sm text-muted-foreground">Zertifizierter Dienstleister mit transparenter Abwicklung.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;